import { ITrackingEvent } from "./tracking-event.interface";

export interface ITracker {
	trackEvent(trackingEvent: ITrackingEvent): Promise<void>;
}
